import React from 'react';
import './Home.css';

const Home = () => {
  const values = [
    {
      title: "Integrity in Craftsmanship",
      description: "We believe in delivering excellence through meticulous attention to detail and honest workmanship."
    },
    {
      title: "Client-Centric Design",
      description: "Your vision is our priority. We create spaces that reflect your personality and meet your needs."
    },
    {
      title: "Long-Term Quality",
      description: "We build lasting relationships through durable, high-quality solutions that stand the test of time."
    },
    {
      title: "Creative Practicality",
      description: "We blend innovative design with functional solutions to create spaces that work beautifully."
    }
  ];

  return (
    <div className="min-h-screen bg-gold-cream">
      {/* Hero Section */}
      <section id="hero-section" className="relative h-screen flex items-center justify-center bg-gold-primary text-black">
        <div className="absolute inset-0 bg-gradient-to-b from-gold-primary/80 to-gold-secondary/80 z-10"></div>
        
        {/* Animated Cubes */}
        <div id="cube1"></div>
        <div id="cube2"></div>
        <div id="cube3"></div>
        <div id="cube4"></div>
        <div id="cube5"></div>
        <div id="cube6"></div>

        {/* Content */}
        <div id="hero-content" className="container mx-auto px-4 z-20 text-center">
          <h1 className="text-6xl font-bold mb-6 tracking-tight">OHM INTERIORS & DOORS</h1>
          <p className="text-2xl mb-8 font-light">Designing Spaces, Building Dreams</p>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8 text-black">Welcome to Ohm Interiors</h2>
            <p className="text-lg text-gold-primary leading-relaxed mb-6">
              Founded as a subsidiary of VTP Groups, Ohm Interiors has been transforming ordinary spaces into elegant, functional environments. Led by a qualified interior designer and supported by a skilled team, we specialize in customized door designs, modular kitchens, and complete interior solutions tailored to your needs.
            </p>
            <p className="text-lg text-gold-primary leading-relaxed">
              With a strong foundation in both aesthetics and practicality, our designs bring beauty, simplicity, and comfort to your everyday spaces.
            </p>
          </div>
        </div>
      </section>

      {/* Decorative Divider
      <div className="relative h-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-gold-cream to-gold-light"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-32 h-1 bg-gold-primary/30 rounded-full"></div>
        </div>
      </div> */}

      {/* Values Section */}
      <section className="py-20 bg-gold-cream">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold mb-12 text-center text-black">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div 
                key={index}
                className="group relative bg-gold-white p-8 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 border border-gold-secondary/20 hover:border-gold-primary/30"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-gold-light to-gold-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
                <div className="relative z-10">
                  <h3 className="text-xl font-semibold mb-4 text-gold-primary">{value.title}</h3>
                  <p className="text-gold-secondary">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
